import { render, staticRenderFns } from "./ProductFile.vue?vue&type=template&id=04db2c4b&"
import script from "./ProductFile.vue?vue&type=script&lang=js&"
export * from "./ProductFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports